(function () {
  'use strict';

  class ProductLabelsComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['product'];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const labels = [];

      // Check for out of stock status (highest priority)
      // If sold out, only show Out of Stock badge
      if (this?._product?.totalInventory === 0) {
        labels.push(`<div class="product-label-wrapper flex">
          <span class="product-label product-label--sold-out">
            Out of Stock
          </span>
        </div>`);
      }
      // Otherwise, check for clearance or sale
      else {
        // Check for clearance status
        // Use collection filter for clearance products
        const onClearance = this?._product?.collections?.includes('Special') || false;

        // Check for sale status
        // Sale is when originalPrice > price
        let onSale = false;
        // Convert to numbers for correct comparison
        const price = parseFloat(this?._product?.priceInfo?.price) || 0;
        const originalPrice = parseFloat(this?._product?.priceInfo?.originalPrice) || 0;

        if (originalPrice > 0 && originalPrice > price) {
          onSale = true;
        }

        // Clearance badge (highest priority after out of stock)
        if (onClearance) {
          labels.push(`<div class="product-label-wrapper flex">
            <span class="product-label on-clearance">
              Clearance
            </span>
          </div>`);
        }

        // Sale badge (if no clearance)
        else if (onSale) {
          labels.push(`<div class="product-label-wrapper flex">
            <span class="product-label on-sale">
              Sale
            </span>
          </div>`);
        }
      }

      this.innerHTML = `
        <div class="product-label-container">
          ${labels.slice(0, 1).join('')}
        </div>
        `;
    }
  }

  customElements.define('rcc-product-labels', ProductLabelsComponent);
})();
